import { createRouter, createWebHistory } from "vue-router";
import RequestformEtax from "@/views/components/etax/RequestForm-Etax.vue";
import RequestformEvrt from "@/views/components/evrt/RequestForm-Evrt.vue";
import Sendotp from "@/views/components/etax/page-form/FormSendEmail.vue";

const routes = [
  {
    path: "/",
    // redirect: "/taxinvoice-etax",
  },
  {
    path: "/taxinvoice-etax",
    name: "RequestformEtax",
    component: RequestformEtax,
    meta: { title: "E-TAX PACIFICA" },
  },
   {
    path: "/taxinvoice-evrt",
    name: "RequestformEvrt",
    component: RequestformEvrt,
        meta: { title: "E-VRT PACIFICA" },
  },
   
   {
    path: "/sendotp",
    name: "Sendotp",
    component: Sendotp,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// ✅ ตั้งค่า title ของหน้าเมื่อเปลี่ยน route
router.beforeEach((to, from, next) => {
  const defaultTitle = "PACIFICA";
  document.title = to.meta.title || defaultTitle;
  next();
});
export default router;
